<script>

    import { createEventDispatcher } from 'svelte'
    import { toast } from 'bulma-toast'

    import LocationsService from '../$services/locations.service'
    import ZipcodesService from '../$services/zipcodes.service'

    import InputEmail from '../$components/input.email.svelte'
    import InputPhone from '../$components/input.phone.svelte'
    import InputText from '../$components/input.text.svelte'
    import Select from '../$components/select.svelte'
    import Form from '../$components/form.svelte'

    const dispatch = createEventDispatcher()

    export let label = null
    export let location = {}
    export let textSave = 'Continuar'
    export let textCancel = 'Regresar'
    export let iconSave = 'chevron-right'
    export let iconCancel = 'chevron-left'

    let loading = false
    let colonies = []
    let query = {
        limit: 9999
    }

    getLocations()

    async function getLocations() {

        loading = true
        const resp = await LocationsService.getLocations(query)
        loading = false

        if(!resp.success) 
            return toast({message: resp.error.message, type: 'is-danger'})

        const place = resp.data.locations.find(item => item.placeId === location.placeId)

        if(place)
            location = {...place}

        getZipcode()
    }

    async function getZipcode() {

        if(!location || !location.zipcode)
            return

        loading = true
        const resp = await ZipcodesService.getZipcode(location.zipcode)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        if(!resp.data)
            return toast({message: 'Código postal no encontrado', type: 'is-danger'})

        location.zipcode = resp.data.zipcode
        location.state = resp.data.state
        location.stateCode = resp.data.stateCode
        location.city = resp.data.city
        location.cityCode = resp.data.cityCode
        location.municipality = resp.data.municipality
        location.municipalityCode = resp.data.municipalityCode

        colonies = resp.data.colonies
    }

    function setLocation() {
        dispatch('selected', location)
    }

    function setColonyCode() {
        const colony = colonies.find(item => item.name === location.colony)
        location.colony = colony.name
        location.colonyCode = colony.code
    }

</script>

{#if label}
    <div class="title is-3">{label}</div>
    <hr>
{/if}
<Form on:submit={ setLocation } on:canceled bind:textSave bind:textCancel bind:iconSave bind:iconCancel {loading} >
    <div class="columns">
        <div class="column">
            <InputText bind:value={location.contact} label="Contacto" icon="user" placeholder="Contacto" />
        </div>
        <div class="column">
            <InputText bind:value={location.company} label="Empresa" icon="building" placeholder="Empresa" required={false} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={location.rfc} label="RFC" icon="fingerprint" placeholder="RFC" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputPhone bind:value={location.phone} label="Teléfono" />
        </div>
        <div class="column">
            <InputEmail bind:value={location.email} label="Correo" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={location.zipcode} label="Código postal" icon="map-marker-alt" readonly={true} />
        </div>
        <div class="column">
            <InputText bind:value={location.state} label="Estado" icon="map-marker-alt" placeholder="Estado" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={location.city} label="Ciudad" icon="map-marker-alt" placeholder="Ciudad" />
        </div>
        <div class="column">
            <InputText bind:value={location.municipality} label="Municipio" icon="map-marker-alt" placeholder="Municipio" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Select 
                on:change={ setColonyCode }
                label="Colonia"
                icon="map-marker-alt"
                bind:value={ location.colony }
                options={colonies.map(item => {
                    return {value: item.name, text: item.name}
                })}
            />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={location.street} label="Calle" icon="map-marker-alt" placeholder="Calle" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={location.number} label="Número exterior" icon="hashtag" placeholder="Número exterior" />
        </div>
        <div class="column">
            <InputText bind:value={location.apartment} label="Número interior" icon="building" placeholder="Número interior" required={false} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={location.references} label="Referencias" icon="asterisk" placeholder="Referencias" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={location.betweenStreets} label="Entre calles" icon="asterisk" placeholder="Entre calles" />
        </div>
    </div>
</Form>